import React from "react";
import './add_button2.css';
import { useTranslation } from "react-i18next";

const SaveButton = ({ text ='Save', onClick, color, backgroundColor, padding }) => {
    const {t} = useTranslation();
    const buttonStyle = {
        cursor: 'pointer', // Ensures the cursor changes to a pointer
    };
    if (backgroundColor) {
        buttonStyle.backgroundColor = backgroundColor;
    }
    if (color) {
        buttonStyle.color = color;
    }
    return (
        <div 
            onClick={onClick} 
            className={`add-button-2 common-text ftw-4 ${padding ? 'padding-cus' : ''}`}
            style={buttonStyle}
        >
            {t(text)}
        </div>
    );
};

export default SaveButton;
